import { render, staticRenderFns } from "./shared-list.vue?vue&type=template&id=d63171c4&scoped=true"
import script from "./shared-list.vue?vue&type=script&lang=js"
export * from "./shared-list.vue?vue&type=script&lang=js"
import style0 from "./shared-list.vue?vue&type=style&index=0&id=d63171c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63171c4",
  null
  
)

export default component.exports